<template>
  <div>
    <v-row>
      <v-col cols="12" md="3">
        <v-select v-model="action" :items="actionItems" label="ประเภทการแก้ไข" outlined dense />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field v-model.trim="searchStudentId" label="รหัสนักศึกษา" maxlength="8" outlined dense clearable />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field v-model.trim="editorId" label="รหัสผู้แก้ไข" outlined dense clearable />
      </v-col>
      <v-col cols="12" md="3">
        <v-btn color="success" block :loading="loading" @click="submit">
          <v-icon left>mdi-magnify</v-icon>
          ค้นหาประวัติ
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      class="history-table"
      :headers="headers"
      :items="rows"
      :loading="loading"
      :items-per-page="15"
      no-data-text="ไม่พบประวัติการแก้ไข"
    >
      <template v-slot:[actionSlot]="{ item }">
        <v-chip small :color="item.action === 'grade' ? 'primary' : 'warning'" outlined>
          {{ item.action === 'grade' ? 'ผลการเรียน' : 'สถานะ' }}
        </v-chip>
      </template>
      <template v-slot:[levelNameSlot]="{ item }">
        <span
          class="font-weight-medium"
          :class="levelTextClass(item.details.student_type)"
        >
          {{ item.details.level_name }}
        </span>
      </template>
      <template v-slot:[summarySlot]="{ item }">
        <template v-if="item.action === 'grade'">
          <span>
            วิชา {{ item.details.subject_id || '-' }}
            ปีการศึกษา {{ item.details.year || '-' }}/{{ item.details.semester || '-' }}
          </span>
          <v-icon
            class="mx-2"
            color="warning"
            size="22"
            aria-label="เปลี่ยนเกรดเป็น"
          >mdi-arrow-right-bold-circle</v-icon>
          <span>
            {{ item.details.old_grade || 'ยังไม่ประกาศ' }}
            → {{ item.details.new_grade || 'ยังไม่ประกาศ' }}
          </span>
        </template>
        <template v-else>
          <span>
            สถานะ {{ item.details.old_status || '-' }}
            → {{ item.details.new_status || '-' }}
          </span>
        </template>
      </template>
      <template v-slot:[referenceDocumentSlot]="{ item }">
        {{ item.details.reference_document || '-' }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'AcademicDataEditHistory',
  props: {
    studentId: { type: String, default: '' },
    initialItems: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    actionSlot: 'item.action',
    levelNameSlot: 'item.details.level_name',
    summarySlot: 'item.summary',
    referenceDocumentSlot: 'item.details.reference_document',
    action: 'all',
    searchStudentId: '',
    editorId: '',
    headers: [
      { text: 'วันเวลา', value: 'created_at', width: 170 },
      { text: 'ประเภท', value: 'action', width: 130 },
      { text: 'รหัสนักศึกษา', value: 'details.student_id', width: 130 },
      { text: 'ระดับการศึกษา', value: 'details.level_name', width: 180 },
      { text: 'รายละเอียด', value: 'summary', width: 360, sortable: false },
      { text: 'เอกสารอ้างอิง/หมายเหตุ', value: 'details.reference_document', width: 240, sortable: false },
      { text: 'ผู้แก้ไข', value: 'details.editor_id', width: 160 },
    ],
  }),
  computed: {
    actionItems() {
      return [
        { text: 'ทั้งหมด', value: 'all' },
        { text: 'แก้ไขผลการเรียน', value: 'grade' },
        { text: 'แก้ไขสถานะ', value: 'status' },
      ]
    },
    rows() {
      return this.initialItems.map((item) => ({
        ...item,
        details: {
          ...(item.details || {}),
          level_name: this.levelName(item.details && item.details.student_type),
        },
        summary: this.summary(item),
      }))
    },
  },
  watch: {
    studentId: {
      immediate: true,
      handler(value) {
        this.searchStudentId = value
      },
    },
  },
  methods: {
    levelTextClass(studentType) {
      return {
        undergraduate: 'blue--text text--darken-2',
        graduate: 'purple--text text--darken-2',
        advance: 'deep-orange--text text--darken-2',
      }[studentType] || 'grey--text text--darken-2'
    },
    clearStudentId() {
      this.searchStudentId = ''
    },
    levelName(studentType) {
      return {
        undergraduate: 'ปริญญาตรี',
        graduate: 'บัณฑิตศึกษา',
        advance: 'บัณฑิตศึกษา (4+1)',
      }[studentType] || '-'
    },
    summary(item) {
      const details = item.details || {}
      if (item.action === 'grade') {
        const oldGrade = details.old_grade || 'ยังไม่ประกาศ'
        const newGrade = details.new_grade || 'ยังไม่ประกาศ'
        return `วิชา ${details.subject_id || '-'} ปีการศึกษา ${details.year || '-'}/${details.semester || '-'} ${oldGrade} → ${newGrade}`
      }
      return `สถานะ ${details.old_status || '-'} → ${details.new_status || '-'}`
    },
    submit() {
      this.$emit('search', {
        action: this.action,
        student_id: this.searchStudentId,
        editor_id: this.editorId,
        limit: 500,
      })
    },
  },
}
</script>

<style scoped>
.history-table ::v-deep table {
  min-width: 1370px;
}
</style>
